import {Component, Input, OnInit} from '@angular/core';
import {FiringSystemDataObject, FurnaceDataObject} from '../facilities-form/facilities-form.domain';
import {EnvironmentService} from '../../services/environment.service';
import {KeyValueData} from '../../domains/common.domain';
import {InstallationFlowType} from '../../constants/app.constants';

@Component({
  selector: 'app-technical-data-heating',
  templateUrl: './technical-data-heating.component.html',
  styleUrls: ['./technical-data-heating.component.scss']
})


export class TechnicalDataHeatingComponent implements OnInit {
  @Input() firingSystemData: FiringSystemDataObject;
  @Input() furnaceData: FurnaceDataObject[];
  @Input() isReadOnly: boolean = false;
  @Input() currentFlowType: string;
  installationFlowType: KeyValueData;

  constructor(public environmentService: EnvironmentService
  ) {
  }

  ngOnInit(): void {
    this.installationFlowType = InstallationFlowType;
  }

}
